import React, { useState } from 'react';
import { gptChatWithData } from '../api'; // Import the chat API function
import { Fab, TextField, Paper, IconButton, Typography, Button } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import SendIcon from '@mui/icons-material/Send';

const FloatingChat = ({data}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSendMessage = async () => {
    if (message.trim()) {
      const userMessage = { role: 'user', content: message };
      const updatedChatHistory = [...chatHistory, userMessage];
      setChatHistory(updatedChatHistory);
      setMessage('');
      setIsLoading(true);

      try {
        const response = await gptChatWithData(message, data); // Use the API function
        const gptReply = { role: 'assistant', content: response.data.reply };
        setChatHistory([...updatedChatHistory, gptReply]);
      } catch (error) {
        console.error('Error communicating with ChatGPT:', error);
        const errorMessage = { role: 'assistant', content: 'Failed to get a response. Please try again later.' };
        setChatHistory([...updatedChatHistory, errorMessage]);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleClearChat = () => {
    setChatHistory([]);
  };

  return (
    <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 1000 }}>
      {isOpen && (
        <Paper
          elevation={3}
          style={{
            padding: '30px',
            marginBottom: '10px',
            display: 'flex',
            flexDirection: 'column',
            width: '600px',
          }}
        >
          <div style={{ flexGrow: 1, overflowY: 'auto', maxHeight: '80vh', marginBottom: '10px' }}>
            {chatHistory.map((msg, index) => (
              <Typography
                key={index}
                style={{
                  textAlign: msg.role === 'user' ? 'right' : 'left',
                  margin: '5px 0',
                  color: msg.role === 'user' ? '#1E90FF' : '#32CD32'
                }}
              >
                <strong>{msg.role === 'user' ? 'You' : 'GPT'}:</strong> {msg.content}
              </Typography>
            ))}
            {isLoading && <Typography>Typing...</Typography>}
          </div>
          <TextField
            fullWidth
            size="small"
            placeholder="Type your message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSendMessage();
              }
            }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
          <Button onClick={handleClearChat} variant="outlined" color="secondary">
              Clear
            </Button>
            <IconButton onClick={handleSendMessage} color="primary" disabled={isLoading}>
              <SendIcon />
            </IconButton>
           
          </div>
        </Paper>
      )}
      <Fab color="primary" onClick={handleToggle}>
        <ChatIcon />
      </Fab>
    </div>
  );
};

export default FloatingChat;
